import request from "./../utils/request"

export function store(data) {
  return request({
    url: "/setLang",
    method: "post",
    data,
  })
}
